import { PromptChatAdapter } from '../../../components/Chat/PromptChatAdapter';
import { designerChatAgentIds, designerChatScopes, useDesignerChatAdapter } from '../../../components/Chat/useDesignerChatAdapter';

export function useServicesChatAdapter(): PromptChatAdapter {
	return useDesignerChatAdapter({
		scopeName: designerChatScopes.services,
		agentId: designerChatAgentIds.domainModeler,
		isAvailable: true,
		missingTargetMessage: 'Sign in to start a Domain Modeller conversation.',
	});
}
